import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Label from "../Label";
import Input, { propTypes as inputPropTypes } from "../Input";

const propTypes = {
  ...inputPropTypes
};
const defaultProps = {};

const FormInputWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

const ErrorMessageWrapper = styled.span`
  color: red;
  width: 100%;
  text-align: left;
  display: block;
  padding-top: 10px;
`;

function FormInput({ error, ...rest }) {
  return (
    <FormInputWrapper>
      <Label hasError={error} {...rest} />
      <Input hasError={error} {...rest} />
      {error && <ErrorMessageWrapper>{error}</ErrorMessageWrapper>}
    </FormInputWrapper>
  );
}

FormInput.propTypes = propTypes;
FormInput.defaultProps = defaultProps;

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/FormInput/index.js